// This is the snack food page

import SnackFoodsComponent from "../../../NonMVPComponents/Recipes/Snacks/SnackFoodsComponent";

const SnackFoods = () => {
  return (
    <div>
      <SnackFoodsComponent />
    </div>
  );
};

export default SnackFoods;
